<script setup lang="ts">
import DatePicker from 'primevue/datepicker';

interface Props {
  title?: string;
  dateRanges?: object[];
  disable?: boolean;
}
defineProps<Props>();

const emits = defineEmits<{
  addNewDate: [];
  removeDate: [indexItem: number];
}>();

const addNewDate = () => {
  emits('addNewDate');
};

const removeDate = (indexItem: number) => {
  emits('removeDate', indexItem);
};
</script>
<template>
  <div class="hotel-date-types flex gap-4 justify-content-start pr-2" :class="title ? 'flex-column' : 'flex-wrap'">
    <div class="flex gap-2 mb-2" v-if="title">
      <div>{{ title }}</div>
      <div class="block text-primary cursor-pointer underline" @click="addNewDate()">+ {{ $t('common.add') }}</div>
    </div>
    <div class="flex gap-1 min-w-5" v-for="(item, index) of dateRanges" :key="index">
      <div class="w-full">
        <label for="start-date-booking">{{ $t('create_quote.start_date') }}<span class="text-primary">*</span></label>
        <DatePicker v-if="title" :disabled="disable" id="start-date-booking" dateFormat="dd-M-yy" v-model="item.start" autocomplete="off" class="w-full" :placeholder="$t('common.date_format')" :minDate="new Date()">
          <template #footer>
            <p class="text-center">
              <small>{{ $t('common.press_space') }}</small>
            </p>
          </template>
        </DatePicker>
        <DatePicker v-else :disabled="disable" id="start-date-booking" dateFormat="dd-M-yy" v-model="item.dateDep" autocomplete="off" class="w-full" :placeholder="$t('common.date_format')" :minDate="new Date()">
          <template #footer>
            <p class="text-center">
              <small>{{ $t('common.press_space') }}</small>
            </p>
          </template>
        </DatePicker>
      </div>
      <div class="w-full">
        <label for="end-date-booking">{{ $t('create_quote.end_date') }}<span class="text-primary">*</span></label>
        <DatePicker v-if="title" :disabled="disable" id="end-date-booking" dateFormat="dd-M-yy" v-model="item.end" autocomplete="off" class="w-full" :placeholder="$t('common.date_format')" :minDate="new Date(item.start)">
          <template #footer>
            <p class="text-center">
              <small>{{ $t('common.press_space') }}</small>
            </p>
          </template>
        </DatePicker>
        <DatePicker v-else :disabled="disable" id="end-date-booking" dateFormat="dd-M-yy" v-model="item.dateRet" autocomplete="off" class="w-full" :placeholder="$t('common.date_format')" :minDate="new Date(item.dateDep)">
          <template #footer>
            <p class="text-center">
              <small>{{ $t('common.press_space') }}</small>
            </p>
          </template>
        </DatePicker>
      </div>
      <div>
        <i class="pi pi-times-circle text-primary text-xl ml-1 pt-1 mt-5 cursor-pointer" :class="dateRanges.length <= 1 && !title ? 'disabled' : ''" @click="removeDate(index)"></i>
      </div>
    </div>
  </div>
</template>
